import React from "react";
import { Container, Box, makeStyles, Grid,useMediaQuery, useTheme } from "@material-ui/core";
import Logo from "../assets/images/logo.PNG";
import { useHistory } from "react-router-dom";
import SlideDownModal from "../components/reusableComponents/SlideDownModal";
import Footer from "./Desktop/Footer";
import SearchEngine from "../form/SearchEngine";
import HeaderSection from "../components/reusableComponents/HeaderSection";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedSector } from "../reducers/UiReducer";
const useStyles = makeStyles(() => ({
  item: {
    //   backgroundColor: "#ee8622",
    display: "flex",
    listStyle: "none",
    marginBottom: 0,
    marginTop: 0,
    "&:hover": {
      backgroundColor: "#ee8622",
    },
  },
  li: {
    color: "white",
    padding: "4px 8px",
    background: "no-repeat",
    borderRight: "none",
  },
  card: {
    padding: 20,
    "&:hover": {
      // backgroundColor: "#ee8622",
      boxShadow: "rgb(149 157 165 / 20%) 0px 8px 24px",
    },
  },
}));
const HomePageFD = () => {
  const classes = useStyles();
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const dispatch = useDispatch();
  const {sector} = useSelector((state)=>state.user)
  const {selectedSector} = useSelector((state)=>state.ui)
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const [header, SetHeader] = React.useState("onlineRecharge");

  const handleClickOpen = () => {
    setOpen(true);
  };
  let originsector = [];
  let destinationsector = [];
  let destinationsectorUnique = [];
  if (sector?.status === 200 && sector?.result.length > 0) {
    originsector = [
      ...new Set(
        sector &&
          sector?.result &&
          sector?.result.length > 0 &&
          sector?.result.map((item) => item.origin)
      ),
    ];
  }
  if (sector?.status === 200 && sector?.result.length > 0) {
    sector &&
      sector?.result &&
      sector?.result.length > 0 &&
      sector.result.map((i) => {
        if (i.origin === selectedSector)
          destinationsector.push({
            ...i,
          });
      });
  }
  if (destinationsector && destinationsector?.length > 0) {
    destinationsectorUnique = [
      ...new Set(
        destinationsector &&
          destinationsector.length > 0 &&
          destinationsector.map((item) => item.destination)
      ),
    ];
  }
  // console.log("sector", originsector);
  // console.log("destinationsector", destinationsector);
  // console.log("destinationsectorUnique", destinationsectorUnique);
  const handleClose = () => {
    setOpen(false);
  };
  const handelHeader = (val) => {
    SetHeader(val);
  };
  return (
    <div>
      <HeaderSection/>
      {/* </Container> */}
      <div style={{ position: "relative" }}>
        <section
          className={classes.back}
          style={{
            height: matches?'':300,
            backgroundImage: `url(${"https://agent.goflysmart.com/img/slider/1.jpg"})`,
          }}
        >
          <SearchEngine />
        </section>
      </div>
      <Container style={{ paddingLeft:matches?0: 50, paddingRight: matches?0: 50, paddingTop: 50 }}>
        <p
          style={{
            textAlign: "center",
            color: "rgb(15, 63, 90)",
            fontSize: 30,
            fontWeight: "bold",
          }}
        >
          Fixed departures available for below Airports
        </p>
        <Grid container>
          {originsector.map((i) => {
            return (
              <Grid item xs={12} lg={3}>
                <Box
                  onClick={()=>{handleClickOpen();dispatch(setSelectedSector(i))}}
                  className={classes.card}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 40,
                    cursor: "pointer",
                    borderRadius: 5,
                  }}
                >
                  <i
                    class="fas fa-map-marker-alt"
                    style={{
                      paddingTop: "6px",
                      fontSize: "2.35rem",
                      color: "rgb(255, 100, 100)",
                    }}
                  ></i>
                  <Box>
                    <p
                      style={{
                        marginLeft: 15,
                        marginBottom: 0,
                        marginTop: 0,
                        color: "rgb(15, 63, 90)",
                        fontWeight: "600",
                        fontFamily: "system-ui",
                        fontSize: "18px",
                      }}
                    >
                      {i}
                    </p>
                    <p
                      style={{
                        marginLeft: 15,
                        marginBottom: 0,
                        marginTop: 0,
                        fontSize: 14,
                        marginTop: 5,
                      }}
                    >
                      {i}
                    </p>
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Container>
      <SlideDownModal
        open={open}
        handleClickOpen={handleClickOpen}
        handleClose={handleClose}
        originsector={originsector}
        destinationsectorUnique={destinationsectorUnique}
      />
      <Footer />
    </div>
  );
};

export default HomePageFD;
